var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-app" },
    [
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("h1", [_vm._v("Haxorpoda Collective")]),
      _vm._v(" "),
      _c("masonary-grid"),
      _vm._v(" "),
      _c("h2", [_vm._v("Ils vont à la chasse aux papillons.")]),
      _vm._v(" "),
      _vm._m(1)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://twitter.com/haxorpoda" } }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: "img/haxorpoda.logo.png",
          alt: "Haxorpoda Collective logo"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("a", { attrs: { href: "https://twitter.com/haxorpoda" } }, [
        _vm._v("@haxorpoda")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47323bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47323bf2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/index.vue
// module id = 28
// module chunks = 0